import { environment } from "environments/environment";

export const featureFlagsInventory:Record<string, boolean> = {
    enablePortableOrder: !environment.production,
}
